export default __webpack_public_path__ + "static/solutions-bg-74983c40bce7aa39576bff089e7cc34e.jpg";